import request from 'services/request';
import { endpoints } from 'services';
import { paramsToFormData } from 'utils/utils';

export default {
  postSales: (params: ProjectListReqDto): Promise<ManagementListResDto> =>
    request({
      url: endpoints.management.sales,
      method: 'post',
      data: paramsToFormData(params),
    }),
  postSalesDetail: (params: ProjectListReqDto): Promise<CommonListResDto> =>
    request({
      url: endpoints.management.salesDetail,
      method: 'post',
      data: paramsToFormData(params),
    }),
  postLecturer: (params: ProjectListReqDto): Promise<CommonListResDto> =>
    request({
      url: endpoints.management.lecturer,
      method: 'post',
      data: paramsToFormData(params),
    }),  
  postLecturerDetail: (params: ProjectListReqDto): Promise<CommonListResDto> =>
    request({
      url: endpoints.management.lecturerDetail,
      method: 'post',
      data: paramsToFormData(params),
    }),     
};


